import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ThemeToggle } from "@/components/ThemeToggle";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

export default function UserDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [resume, setResume] = useState<File | null>(null);

  const handleNext = () => {
    if (email && resume) {
      navigate("/interview", {
        state: {
          ...location.state,
          email,
          resume,
        },
      });
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-background to-background/80">
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>

      <div className="container mx-auto max-w-md px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-8"
        >
          <div className="text-center">
            <h1 className="mb-4 text-3xl font-bold">Your Details</h1>
            <p className="text-muted-foreground">
              Please provide your contact information
            </p>
          </div>

          <div className="space-y-4">
            <Input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={(e) => setResume(e.target.files?.[0] || null)}
            />
          </div>

          <div className="flex justify-end space-x-4">
            <Button
              variant="outline"
              onClick={() => navigate("/select-company")}
            >
              Back
            </Button>
            <Button onClick={handleNext} disabled={!email || !resume}>
              Start Interview
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}